module.exports = __webpack_public_path__ + "img/bsidd-1.840831f3.webp";